<template>
  <v-container fluid class="rbu-edition-detail" v-if="contractYear">
    <v-row class="flex-grow-0">
      <v-btn
        text
        color="primary"
        exact
        :to="{ name: 'contract-percentage-list' }"
      >
        <h3 class="font-weight-regular">
          &lt;&lt; Contract Year {{ contractYear.year }}
        </h3>
      </v-btn>
    </v-row>

    <v-row
      v-if="canEditConfig"
      class="rbu-edition-info-wrapper"
      style="margin-bottom: 1rem"
    >
      <v-col>
        <h3>Configure: {{ contractYear.year }}</h3>
      </v-col>
      <v-btn v-if="contractYear" color="primary" @click="save">Save </v-btn>
    </v-row>

    <v-row v-else class="rbu-edition-info-wrapper" style="margin-bottom: 1rem">
    </v-row>

    <v-form>
      <!-- <v-text-field
        outlined
        type="text"
        :label="$t('rbu.rbu_edition_name')"
        v-model="edition.name"
        :rules="requiredRules"
        :disabled="
          (edition && edition.updating_selected_rate) || !canEditConfig
        "
      ></v-text-field>  -->

      <!-- <RbuPeriodInput
          :label="$t('rbu.latest')"
          v-model="edition.latest"
          :rules="requiredRules"
        ></RbuPeriodInput> -->
      <v-select
        v-model="contractYear.selected_dataset"
        :items="dataset"
        chips
        label="Datasets"
        multiple
        outlined
        :disabled="!canEditConfig"
      ></v-select>

      <RbuPeriodInput
        :label="$t('rbu.base_start')"
        v-model="contractYear.base_start"
        :rules="requiredRules"
        :disabled="!canEditConfig"
        :min="min"
        :max="max"
      ></RbuPeriodInput>
      <RbuPeriodInput
        :label="$t('rbu.base_end')"
        v-model="contractYear.base_end"
        :rules="requiredRules"
        :disabled="!canEditConfig"
        :min="min"
        :max="max"
      ></RbuPeriodInput>

      <v-text-field
        outlined
        type="number"
        min="0"
        step=".000000000000001"
        suffix="%"
        :label="$t('rbu.contract_percentage')"
        v-model="contractYear.contract_percentage"
        :rules="requiredRules"
        :disabled="!canEditConfig"
      ></v-text-field>
    </v-form>
  </v-container>
</template>
<script>
import { ACTION_TYPES } from "@/store/types";
import {
  onMounted,
  onUnmounted,
  ref,
  computed,
  watch,
} from "@vue/composition-api";
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";
import { USER_TYPE } from "@/constants";
import floatingPointFix from "js-floating-point";

export default {
  name: "ContractPercentageYearConfig",
  components: { RbuPeriodInput },
  setup(props, { root }) {
    const min = ref(undefined);
    const max = ref(undefined);
    const dataset = ref([]);
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const contractYear = ref(null);
    const canEditConfig = computed(() => {
      return true;
      // if (!root.$store.getters.account) return false;
      // return [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].includes(
      //   root.$store.getters.account.type
      // );
    });
    const getContractYear = async function (not_blocking = true) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/contract_percentage/contract_percentage_year/",
        params: {
          contract_percentage_id: root.$route.params.contract_percentage_id,
        },
      });

      if (response && response.data && response.data.success) {
        contractYear.value = response.data.contract_percentage_year;
        contractYear.value.contract_percentage = floatingPointFix(
          contractYear.value.contract_percentage
        );
      }
    };

    const getDataset = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/",
        params: {},
      });

      if (response && response.data && response.data.success) {
        dataset.value = response.data.datasets.map((d) => {
          return {
            text: `[${d.alias}]`,
            value: d.id,
          };
        });
      }
    };

    const save = async function () {
      if (
        await root.$dialog.confirm({
          text: `Are you sure to update the master configure of this Contract Percentage - [${contractYear.value.year}]?`,
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/contract_percentage/contract_percentage_year/set_config/",
          params: {
            contract_id: root.$route.params.contractId,
            contract_year_id: root.$route.params.contract_percentage_id,
            ...contractYear.value,
          },
        });

        getContractYear();
      }
    };

    const getAvailablePeriod = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/available_data_period/",
        params: {
          datasets: contractYear.value.selected_dataset,
        },
      });

      if (response && response.data && response.data.success) {
        min.value = response.data.min;
        max.value = response.data.max;
      }
    };

    onMounted(() => {
      getContractYear();
      getDataset();
      getAvailablePeriod();
    });

    watch(
      () => contractYear.value.selected_dataset,
      (newValue, _) => {
        getAvailablePeriod();
      }
    );

    return {
      requiredRules,
      canEditConfig,
      contractYear,

      save,
      min,
      max,
      dataset,
    };
  },
};
</script>

<style lang="less">
.rbu-edition-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rbu-edition-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .rbu-edition-info {
      flex: 1 1 0;
    }
  }
}
</style>
